
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Curriculumleft from './Curriculumleft';

const AcademicCalenderEle = () => {
    const curriculumData = [
        {
            programme: 'Master of Public Policy (MPP) Program',
            curricula: [
                {
                    batch: '2022–23 onwards',
                    url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/MPP_2022-23.pdf',
                },
            ],
        },
    ];

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col
                        md={4}
                        className="c-left custom-padding-color mb-4"
                    >
                        <Curriculumleft activeIndex={4} />
                    </Col>

                    <Col md={8} className="c-right mt-2 ps-5">
                        <h3 className="text-center mb-5">
                            Master of Public Policy (MPP) Curriculum
                        </h3>

                        <h5>
                            Curriculum for the Master of Public Policy (MPP)
                            Programme is listed below:
                        </h5>

                        <table className="table table-bordered table-hover align-middle mt-4">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th width="15%">S.No.</th>
                                    <th width="50%">Programme</th>
                                    <th width="35%">Curriculum</th>
                                </tr>
                            </thead>

                            <tbody>
                                {curriculumData.map((programme, index) =>
                                    programme.curricula.map(
                                        (item, itemIndex) => (
                                            <tr
                                                key={`${index}-${itemIndex}`}
                                                className={
                                                    index % 2 === 0
                                                        ? 'table-light'
                                                        : 'table-secondary'
                                                }
                                            >
                                                {itemIndex === 0 && (
                                                    <>
                                                        <td
                                                            rowSpan={
                                                                programme
                                                                    .curricula
                                                                    .length
                                                            }
                                                            className="text-center align-middle fw-bold"
                                                        >
                                                            {index + 1}
                                                        </td>

                                                        <td
                                                            rowSpan={
                                                                programme
                                                                    .curricula
                                                                    .length
                                                            }
                                                            className="align-middle fw-bold"
                                                        >
                                                            {programme.programme}
                                                        </td>
                                                    </>
                                                )}

                                                <td>
                                                    <Link
                                                        to={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none"
                                                    >
                                                        <i className="fas fa-file-pdf text-danger me-2"></i>
                                                        {item.batch}
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    )
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AcademicCalenderEle;
